function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100)
}

$(document).ready(function () {
    // The bar is rendered by snippets/shipping-calculator_vjs.liquid:
    // - the shipping icon always marks the free shipping goal (grey until
    //   reached, green once unlocked),
    // - the gift icon appears as soon as free shipping is unlocked and turns
    //   green when the free gift goal is reached.
    function updateGoalContainer(container, cart) {
        const shipGoal = parseInt(container.dataset.freeShippingGoal, 10) || 0;
        const giftGoal = parseInt(container.dataset.freeGiftGoal, 10) || 0;
        const hasShippingTier = container.dataset.hasShippingTier === 'true';
        const hasGiftTier = container.dataset.hasGiftTier === 'true';
        const barMax = parseFloat(container.dataset.barMax) || Math.max(shipGoal, giftGoal) || 1;

        const total = cart.total_price;
        const shippingReached = hasShippingTier && total >= shipGoal;
        const giftReached = hasGiftTier && total >= giftGoal;

        let state = 'success';
        if (hasShippingTier && total <= 0) {
            state = 'zero';
        } else if (hasShippingTier && !shippingReached) {
            state = 'shipping';
        } else if (hasGiftTier && !giftReached) {
            state = 'gift';
        }

        const texts = {
            zero: container.querySelector('.free-shipping-text-zero'),
            shipping: container.querySelector('.free-shipping-text'),
            gift: container.querySelector('.free-gift-text'),
            success: container.querySelector('.success-text')
        };
        Object.keys(texts).forEach((key) => {
            if (texts[key]) {
                texts[key].classList.toggle('d-none', key !== state);
            }
        });

        container.querySelectorAll('.remaining-price-shipping').forEach((el) => {
            el.textContent = formatMoney(Math.max(0, shipGoal - total));
        });

        container.querySelectorAll('.remaining-price-gift').forEach((el) => {
            el.textContent = formatMoney(Math.max(0, giftGoal - total));
        });

        const shippingEl = container.querySelector('.free-shipping-threshold');
        if (shippingEl) {
            shippingEl.classList.toggle('reached', shippingReached);
            shippingEl.style.width = (Math.min(shipGoal / barMax, 1) * 100) + '%';
        }

        const giftEl = container.querySelector('.free-gift-threshold');
        if (giftEl) {
            giftEl.classList.toggle('reached', giftReached);
            const giftIcon = giftEl.querySelector('.tooltip');
            if (giftIcon) {
                giftIcon.classList.toggle('d-none', !shippingReached);
            }
        }

        const fillEl = container.querySelector('.goal-reached');
        if (fillEl) {
            fillEl.style.width = (Math.min(total / barMax, 1) * 100) + '%';
        }
    }

    function updateGoalContainers(cart) {
        if (!cart || typeof cart.total_price !== 'number') {
            return;
        }
        document.querySelectorAll('.goal-container').forEach((container) => {
            updateGoalContainer(container, cart);
        });
    }

    // CartJS driven changes (e.g. quantity updates) emit cart.requestComplete,
    // but the Vue cart app changes the cart through window.__CART_INSTANCE__
    // (add / update / remove / getState) without emitting that event. Wrap its
    // state-loading methods so the bar also refreshes on those changes.
    function patchCartInstance() {
        const cartInstance = window.__CART_INSTANCE__;
        if (!cartInstance || cartInstance.__goalBarPatched) {
            return !!cartInstance;
        }
        cartInstance.__goalBarPatched = true;
        ['getState', 'update'].forEach((name) => {
            const original = cartInstance[name];
            if (typeof original !== 'function') {
                return;
            }
            cartInstance[name] = function () {
                const result = original.apply(this, arguments);
                if (result && typeof result.then === 'function') {
                    return result.then((cart) => {
                        updateGoalContainers(cart && typeof cart.total_price === 'number' ? cart : this.state);
                        return cart;
                    });
                }
                return result;
            };
        });
        return true;
    }

    let cartPatchAttempts = 0;
    function ensureCartInstancePatched() {
        if (patchCartInstance()) {
            return;
        }
        cartPatchAttempts += 1;
        if (cartPatchAttempts <= 20) {
            window.setTimeout(ensureCartInstancePatched, 500);
        }
    }

    $(document).on('cart.requestComplete', function (event, cart) {
        updateGoalContainers(cart);
    });

    updateGoalContainers(window.SHYNE && window.SHYNE.cart);
    ensureCartInstancePatched();
});
